export const clientsActivitiesListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'riskCategory',
    label: 'Risk category',
  },
  {
    name: 'riskScore',
    label: 'Score',
  },
  {
    name: 'name',
    label: 'Activity of the individual client',
  },
];

export const clientsActivitiesListDefaultSorter = {};

export const clientsActivitiesListSchema = {};

export const clientsActivitiesListFiltersSchema = [];
